import type { AlpineComponent } from 'alpinejs'

export function vintageFilter(): AlpineComponent<{
  selectedVintage: string | null
  selectVintage: (vintage: string | null) => void
  isActive: (vintage: string | null) => boolean
  applyFromHash: () => void
  filterProducts: () => void
  scrollToProducts: () => void
}> {
  return {
    selectedVintage: null,

    init() {
      this.applyFromHash()
      window.addEventListener('hashchange', () => this.applyFromHash())
    },

    applyFromHash() {
      const hash = window.location.hash.slice(1)
      this.selectedVintage = hash || null
      this.filterProducts()
    },

    selectVintage(vintage: string | null) {
      const { pathname, search } = window.location

      if (vintage) {
        this.selectedVintage = vintage
        window.location.hash = vintage
      } else {
        history.replaceState(null, '', `${pathname}${search}`)
        this.selectedVintage = null
      }

      this.filterProducts()
      this.scrollToProducts()
    },

    isActive(vintage: string | null) {
      return this.selectedVintage === vintage
    },

    filterProducts() {
      this.$root.querySelectorAll('.products article').forEach((article) => {
        const el = article as HTMLElement
        const vintage = el.dataset.vintage ?? null
        const show = !this.selectedVintage || vintage === this.selectedVintage
        el.classList.toggle('hidden', !show)

        if (show && el.classList.contains('fade-up') && !el.classList.contains('animated')) {
          el.classList.add('animated')
        }
      })
    },

    scrollToProducts() {
      const products = this.$root.querySelector('.products') as HTMLElement | null
      if (!products) return

      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth'

      products.scrollIntoView({ behavior, block: 'start' })
    },
  }
}
